import { z } from 'zod'

export const trainerCertificateExceptionResponseSchema = z.record(z.unknown())
export type TrainerCertificateExceptionResponse = z.infer<typeof trainerCertificateExceptionResponseSchema>
